var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighFiveStreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1399 1.6557L11.819 3.72766",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2863 2.09534L15.5952 4.16334",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3955 5.46063L18.449 6.44318",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2155 7.89941C9.41794 7.59497 8.64754 7.3627 7.81785 7.24792C6.22665 7.02776 5.0487 8.49443 5.06831 10.1007L5.13548 14.7943L4.52189 14.0504C3.87372 13.2646 2.66934 13.266 2.02308 14.0534C1.55803 14.62 1.532 15.4285 1.95965 16.0238L3.27065 17.849C3.79876 18.5696 4.45348 19.1882 5.20285 19.6747L5.74282 20.0253C6.31755 20.1295 6.88582 20.2099 7.45061 20.266",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7296 19.6936C20.2014 20.4143 19.5467 21.0329 18.7975 21.5194C17.3058 22.4876 14.9533 22.4428 12.9179 22.1888C11.675 22.0338 10.6593 21.1031 10.4527 19.8677C10.0089 17.2146 10.1556 14.6704 10.8929 11.9454C11.2193 11.1884 11.8253 10.5644 12.6091 10.2269C13.8571 9.68945 14.9549 9.26245 16.1824 9.09262C17.7736 8.87247 18.9515 10.3391 18.932 11.9454L18.8648 16.639L19.4783 15.8951C20.1265 15.1093 21.3309 15.1107 21.9772 15.8981C22.4422 16.4647 22.4683 17.2732 22.0407 17.8685L20.7296 19.6936Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFiveStreamlineFlex1);
export default __webpack_public_path__ + "static/media/High-Five--Streamline-Flex 1.864ac156a2846e496ea6987126265aa6.svg";
export { ForwardRef as ReactComponent };